import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import ComercioExteriorMercanciaDescripcionesEspecificasForm from './ComercioExteriorMercanciaDescripcionesEspecificasForm';
import ComercioExteriorMercanciaDescripcionesEspecificasList from './ComercioExteriorMercanciaDescripcionesEspecificasList';

class ComercioExteriorMercanciaDescripcionesEspecificasManager extends Component {
  state = {}

  handleOnAdd = (data) => {
    const { DescripcionesEspecificas = [] } = this.props.data;

    const newData = DescripcionesEspecificas.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const newData = {
      DescripcionesEspecificas: data
    }

    this.props.onChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { DescripcionesEspecificas =  [] } = this.props.data;

    return (
      <>
        <fieldset>
          <legend>Descripciones Específicas</legend>

          <ComercioExteriorMercanciaDescripcionesEspecificasForm
            data={ data }
            onAdd={ this.handleOnAdd }
          />

          <ComercioExteriorMercanciaDescripcionesEspecificasList
            data={ DescripcionesEspecificas }
            onEdit={ this.handleOnEdit }
            onChange={ this.handleOnListChange }
          />
        </fieldset>
      </>
    )
  }
}

export default ComercioExteriorMercanciaDescripcionesEspecificasManager;